/**
 * @param {object} FullContact contenedor padre del listado de contactos
 */
const FullContact = $(".container-full-contact");

if (FullContact.length == 1) {
    /**
     *
     * @param {number} num
     * @param {object} objetContact
     */
    function initContact(num) {
        /**
         * @param {object} this.this.containerC Capa interior del padre para encapsular capas menores
         */
        this.containerC = $("<div>").addClass("container-contact-client");
        /**
         * @param {object} this.contactRow Capara para ordenar componentes a traves de la clase row
         */
        this.contactRow = $("<div>")
            .addClass("contact-container row")
            .appendTo(this.containerC);
        /**
         * @param {object} this.titleContact Capara para el titulo (cabecera)
         */

        this.titleContact = $("<div>")
            .addClass("col s12 title-contact")
            .appendTo(this.contactRow);
        $("<h1>")
            .text("Contacto " + num)
            .appendTo(this.titleContact);

        /**
         * @param {objet} this.contactBody (Cuerpo)
         */
        this.contactBody = $("<div>")
            .addClass("contact-body col s12")
            .appendTo(this.contactRow);
        /**
         * @param this.contactComment Contenedor del texto del contacto
         */
        this.contactComment = $("<div>")
            .addClass("contact-comment col s12")
            .appendTo(this.contactRow);

        //this.h1 = $("<h1>").appendTo(this.contactComment);
        this.note = $("<div>")
            .addClass("col s12")
            .appendTo(this.contactComment);
        /**
         * @param contactFooter Contenedor del bottom Editar
         */
        this.contactFooter = $("<div>")
            .addClass("contact-footer col s12 center-align")
            .appendTo(this.contactRow);
        $("<a>")
            .click(activeModal)
            .text("Editar")
            .addClass("waves-effect btn")
            //.attr('href','#modalEditContact')
            .appendTo(this.contactFooter);
    }

    /**
     *
     * @param {objet} obj Propiedad que contiene los datos
     * @function contactBody_set Extracción de datos y agregando a objeto con clase row
     */
    initContact.prototype.contactBody_set = function(obj) {
        const ClassRow = $("<div>")
            .addClass("row")
            .appendTo(this.contactBody);
            this.containerC.attr("id","contact-"+obj.id);
        /**
         * @param {objet} search Elementos a buscar
         */
        const search = {
            name: "Nombre",
            phone: "Teléfono",
            position: "Cargo",
            cellphone: "Celular",
            department: "Departamento",
            mail: "Mail",
            note: this.note
        };

        const group = 2;
        let cont = 1;
        let capa_conteDatos;
        for (const key in search) {
            if (search.hasOwnProperty(key)) {
                if (typeof search[key] == "object") {
                    search[key].text(obj[key]).addClass("input_" + key);
                } else {
                    if (cont == 1) {
                        capa_conteDatos = $("<div>")
                            .addClass("col s12 capa_conte")
                            .appendTo(ClassRow);
                    }
                    const capa_H1 = $("<div>")
                        .addClass("col s6")
                        .appendTo(capa_conteDatos);
                    const h1 = $("<h1>").appendTo(capa_H1);
                    $("<div>")
                        .text(search[key])
                        .addClass("col s4 title_cont")
                        .appendTo(h1);
                    $("<div>")
                        .text(obj[key])
                        .addClass("col s8 input_" + key)
                        .appendTo(h1);
                    cont++;
                    cont = cont > group ? 1 : cont;
                }
            }
        }

        const ElementContact = $(".container-full-contact").append(
            this.containerC
        );
        ElementContact.appendTo(FullContact);
    };
    const search_Contar = [
        "name",
        "phone",
        "position",
        "cellphone",
        "department",
        "mail",
        "note"
    ];
    var instance;
    function activeModal(e) {
        const datos = $(e.target).parents(".container-contact-client");
        $("#idContact").val(datos[0].id.split("-")[1])
        const modals = $(".modalEditContact").modal();
        instance = M.Modal.getInstance(modals[0]);
        instance.options.dismissible = false;
        const elModal = instance.$el[0];

        for (let index = 0; index < search_Contar.length; index++) {
            const elem = search_Contar[index];
            //console.log($(datos[0].querySelector('.input_'+elem)).text());
            const nodo = $(elModal.querySelector(".inputM_" + elem));
            const nodoCont = $(datos[0].querySelector(".input_" + elem));
            let result = "";
            if (nodoCont[0].nodeName == "INPUT") {
                result = nodoCont.val();
            } else {
                result = nodoCont.text();
            }
            if (nodo[0].nodeName == "INPUT") {
                nodo.val(result);
            } else {
                nodo.text(result);
            }
        }
        instance.open();
    }

    $("#modalEditContact > div.modal-footer > div > a").click(function(e) {
        $.ajax({
            url: https + "editarProspectClient",
            method: "POST",
            data: $("#formContact").serialize(),
            success: function(data) {
                if ($.trim(data[0]) == "1") {
                    const ContactUpdate=$("#contact-"+data[1].id)[0];
                    for (const key in search_Contar) {
                        if (search_Contar.hasOwnProperty(key)) {
                            const elem = search_Contar[key];
                            //console.log(data[1]);
                            const nodoCont=$(ContactUpdate.querySelector(".input_" + elem));
                            if (nodoCont.nodeName == "INPUT") {
                                nodoCont.val(data[1][elem]);
                            } else {
                                nodoCont.text(data[1][elem]);
                            }                     
                        }
                    }
                    instance.close();
                } else if ($.trim(data) == "2") {
                    swal({
                        text: "No tiene los permisos necesarios",
                        icon: imageURL,
                        button: "OK!"
                    });
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!"
                    });
                }
            }
        });
    });

    $(document).ready(function() {
        $.ajax({
            url: https + "contactProspectClient",
            method: "POST",
            data: {
                idViewsCliPros: $("#idViewsCliPros").val(),
                type_user: $("#type_user").val(),
                iduser: $("#iduser").val()
            },
            success: function(data) {
                if ($.trim(data[0]) == "1") {
                    console.log(data);
                    for (const key in data[1]) {
                        if (data[1].hasOwnProperty(key)) {
                            const element = data[1][key];
                            new initContact(
                                $(".container-contact-client").length + 1
                            ).contactBody_set(element);
                        }
                    }
                    let cont=0;

                    const effectC=setInterval(() => {
                        const nodeElm = $($(".container-contact-client")[cont]);
                        nodeElm.addClass("container-effect_none");
                        setTimeout(() => {
                            nodeElm.addClass("container-effect");
                        }, 10);
                        if(cont==$(".container-contact-client").length){
                            clearInterval(effectC)
                        }
                        cont++;
                    }, 300);

                } else if ($.trim(data) == "2") {
                    swal({
                        text: "No tiene los permisos necesarios",
                        icon: imageURL,
                        button: "OK!"
                    });
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!"
                    });
                }
            }
        });
    });
}
